import { useEffect } from "react";

const Calculate = ({ input2, onMultiplierChange }) => {
  useEffect(() => {
    let calculatedMultiplier = 0;

    if (input2 >= 0 && input2 <= 250) {
      calculatedMultiplier = 0.1;
  } else if (input2 >= 250 && input2 < 2500) {
      calculatedMultiplier = 0.5;
  } else if (input2 >= 2500 && input2 < 5000) {
      calculatedMultiplier = 1;
  } else if (input2 >= 5000 && input2 < 25000) {
      calculatedMultiplier = 1.2;
  } else if (input2 >= 25000 && input2 < 50000) {
      calculatedMultiplier = 1.4;
  } else if (input2 >= 50000 && input2 < 100000) {
      calculatedMultiplier = 2;
  } else if (input2 >= 100000 && input2 < 125000) {
      calculatedMultiplier = 3;
  } else if (input2 >= 125000 && input2 < 150000) {
      calculatedMultiplier = 3.25;
  } else if (input2 >= 150000 && input2 < 175000) {
      calculatedMultiplier = 3.5;
  } else if (input2 >= 175000 && input2 < 225000) {
      calculatedMultiplier = 4;
  } else if (input2 >= 225000 && input2 < 250000) {
      calculatedMultiplier = 5;
  } else if (input2 >= 250000 && input2 < 500000) {
      calculatedMultiplier = 6;
  } else if (input2 >= 500000 && input2 < 750000) {
      calculatedMultiplier = 10;
  } else if (input2 >= 750000 && input2 < 1000000) {
      calculatedMultiplier = 12;
  } else if (input2 >= 1000000 && input2 < 2000000) {
      calculatedMultiplier = 15;
  } else if (input2 >= 2000000 && input2 < 3000000) {
      calculatedMultiplier = 20;
  } else if (input2 >= 3000000 && input2 < 4000000) {
      calculatedMultiplier = 30;
  } else if (input2 >= 4000000 && input2 < 5000000) {
      calculatedMultiplier = 40;
  } else if (input2 >= 5000000) {
      calculatedMultiplier = 60;
  }
  

    // Multiplier'ı dışarıdaki fonksiyona gönderiyoruz
    onMultiplierChange(calculatedMultiplier);
  }, [input2, onMultiplierChange]);

  return null; // Bu bileşen görünür bir şey döndürmek zorunda değil
};

export default Calculate;